import ApiInstance from './instance'
import {
  IAdminTask,
  EAdminTaskStatus,
  EOnboardingMilestoneStatus,
  IOnboarding,
  IOnboardingMilestoneTemplate
} from '@zunta/configurations'

export default class OnboardingApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }
  saveTemplateOrder (templates: IOnboardingMilestoneTemplate[]) {
    return this.instance.doPut('/onboarding/saveTemplatesOrder', { templates })
  }
  editOnboardingTemplate (id: number | string, data: Partial<IOnboardingMilestoneTemplate>) {
    return this.instance.doPatch(`/onboarding/editMilestoneTemplate/${id}`, data)
  }
  deleteOnboardingTemplate (id: number | string) {
    return this.instance.doDelete(`/onboarding/deleteMilestoneTemplate/${id}`)
  }
  createMilestoneTemplate (data: { parent?: number, name: string }) {
    return this.instance.doPatch('/onboarding/createMilestoneTemplate', data)
  }
  getOnboardingMilestoneStatistic () {
    return this.instance.doGet('/onboarding/milestones-statistics')
  }
  updateTask (taskId: number | string, data: Partial<IAdminTask>, template: number | undefined) {
    return this.instance.doPut(`/onboarding/adminTask/update/${taskId}`, {
      task: data,
      template
    })
  }
  updateUserTask (taskId: number | string, data: Partial<IAdminTask>, template: number | undefined) {
    return this.instance.doPut(`/onboarding/adminTask/user/update/${taskId}`, {
      task: data,
      template
    })
  }
  addAdminTask (data: any) {
    return this.instance.doPost(`/onboarding/adminTask/add`, data)
  }
  addUserAdminTask (data: any) {
    return this.instance.doPost(`/onboarding/adminTask/user/add`, data)
  }
  getOnboardingTemplates () {
    return this.instance.doGet(`/onboarding/templates/all`)
  }
  fetchTrainingTemplates () {
    return this.instance.doGet(`/onboarding/templates/training/all`)  
  }
  getAdminTasks (chainId: number | string): Promise<IAdminTask[]> {
    return this.instance.doGet(`/onboarding/adminTasks/${chainId}`)  
  }
  getUserAdminTasks (userId: number | string): Promise<IAdminTask[]> {
    return this.instance.doGet(`/onboarding/adminTasks/user/${userId}`)
  }
  rescheduleTask (id: number | string, date: Date | string | number, note: string) {
    return this.instance.doPut(`/onboarding/rescheduleTask/${id}`, { date, note })
  }
  changeAdminTaskStatus (id: number | string, data: { status: EAdminTaskStatus, note: string }) {
    return this.instance.doPut(`/onboarding/changeAdminTaskStatus/${id}`, data)
  }
  addAdminTaskHistoryComment (taskId: number | string, data: any) {
    return this.instance.doPost(`/onboarding/adminTaskHistory/comment/${taskId}`, data)
  }
  getTaskHistories (taskId: number | string) {
    return this.instance.doGet(`/onboarding/adminTaskHistories/${taskId}`)
  }
  changeMilestoneStatus (id: number | string, status: EOnboardingMilestoneStatus) {
    return this.instance.doPatch(`/onboarding/changeMilestoneStatus/${id}`, { status })
  }
  getOnboardingData (chainId: number | string) {
    return this.instance.doGet(`/onboarding/data/${chainId}`)
  }
  updateOnboarding (onboardingId: number | string, data: Partial<IOnboarding>) {
    return this.instance.doPatch(`/onboarding/update/${onboardingId}`, data)
  }
}
